import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@components/shadcn-ui/card";
import { Button } from "@components/shadcn-ui/button";
import { Edit, User, Loader2 } from "lucide-react";
import { addressService, AddressResponse } from "../service/addressService";

export interface ReferenceData {
  addressId: string;
  relationToApplicant: string;
  personalDetails: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
  };
}

interface ReferenceCardProps {
  reference: ReferenceData;
  onEdit: () => void;
  index: number;
  applicationId: string;
  onDelete?: () => void; // Make onDelete optional
}

export const ReferenceCard: React.FC<ReferenceCardProps> = ({
  reference,
  onEdit,
  index,
  applicationId,
  onDelete
}) => {
  const [address, setAddress] = useState<AddressResponse | null>(null);
  const [isLoadingAddress, setIsLoadingAddress] = useState(false);
  console.log(onDelete);
  useEffect(() => {
    const fetchAddress = async () => {
      if (!applicationId || !reference.addressId) return;
      
      setIsLoadingAddress(true);
      try {
        const addressData = await addressService.getAddressById(applicationId, reference.addressId);
        setAddress(addressData);
      } catch (error) {
        console.error("Error fetching address:", error);
      } finally {
        setIsLoadingAddress(false);
      }
    };

    fetchAddress();
  }, [applicationId, reference.addressId]);

  // Format address for display
  const formatAddress = () => {
    if (!address) return null;
    
    const parts = [
        address.type,
      address.line1,
      address.line2,
      address.landmark,
      address.city,
      address.state,
      address.postalCode,
      address.country
    ].filter(Boolean);
    
    return parts.join(", ");
  };

  return (
    <Card className="overflow-hidden">
      <CardContent className="p-0">
        <div className="bg-gray-50 p-3 flex justify-between items-center">
          <div className="flex items-center">
            <div className="bg-primary/10 p-2 rounded-full">
              <User className="h-5 w-5 text-primary" />
            </div>
            <h3 className="ml-2 font-medium">Reference #{index + 1}</h3>
          </div>
          <div className="flex space-x-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={onEdit}
              className="h-8 w-8 p-0"
            >
              <Edit className="h-4 w-4" />
              <span className="sr-only">Edit</span>
            </Button>
            {/*
            {onDelete && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onDelete}
                className="h-8 w-8 p-0 text-red-500 hover:text-red-600 hover:bg-red-50"
              >
                <Trash2 className="h-4 w-4" />
                <span className="sr-only">Delete</span>
              </Button>
            )}
            */}
          </div>
        </div>
        <div className="p-4">
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <div>
              <p className="text-gray-500">Name</p>
              <p className="font-medium">
                {reference.personalDetails.firstName} {reference.personalDetails.lastName}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Relation</p>
              <p className="font-medium">{reference.relationToApplicant}</p>
            </div>
            <div>
              <p className="text-gray-500">Phone Number</p>
              <p className="font-medium">{reference.personalDetails.phoneNumber}</p>
            </div>
            <div className="col-span-2">
              <p className="text-gray-500">Address</p>
              {isLoadingAddress ? (
                <div className="flex items-center">
                  <Loader2 className="h-3 w-3 animate-spin mr-2" />
                  <span className="text-sm">Loading address...</span>
                </div>
              ) : address ? (
                <p className="font-medium text-sm">{formatAddress()}</p>
              ) : (
                <p className="text-xs text-gray-400">Address ID: {reference.addressId}</p>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
